import type { LandingPageContent } from '../types'

export const DOFINANSOWANIE_FOTOWOLTAIKI: LandingPageContent = {
  slug: 'dofinansowanie-fotowoltaiki',
  lang: 'pl',
  topicId: 'photovoltaik-foerderung',
  title: 'Dofinansowanie fotowoltaiki w Niemczech: KfW, taryfa gwarantowana i dotacje',
  metaDescription:
    'Dofinansowanie na poziomie federalnym, krajowym i gminnym w Niemczech - i jak mimo to ' +
    'uczciwie porównać oferty. Stan na: sierpień 2026, do sprawdzania co roku.',
  keywords: [
    'dofinansowanie fotowoltaiki niemcy',
    'kfw fotowoltaika',
    'taryfa gwarantowana einspeisevergütung',
    'dotacja fotowoltaika niemcy',
    'podatek fotowoltaika niemcy',
    'dofinansowanie magazynu energii',
  ],
  eyebrow: 'Dofinansowanie · Stan na: sierpień 2026',
  h1: 'Dofinansowanie fotowoltaiki w Niemczech: co warto wiedzieć w 2026',
  intro:
    'Dofinansowanie zmienia rzeczywistą cenę końcową instalacji solarnej często bardziej niż ' +
    'jakiekolwiek negocjacje ceny. Ta strona podsumowuje najważniejsze punkty na poziomie ' +
    'federalnym i wyjaśnia, dlaczego dofinansowanie niczego nie zmienia w uczciwym porównaniu ofert.',
  sections: [
    { type: 'heading', text: 'Poziom federalny: najważniejsze punkty' },
    {
      type: 'list',
      items: [
        '0% VAT na zakup i montaż mniejszych instalacji fotowoltaicznych - obowiązuje bezterminowo',
        'Dochody z prywatnych instalacji fotowoltaicznych do 30 kWp są zwolnione z podatku dochodowego - bez konieczności zakładania działalności',
        'Taryfa gwarantowana EEG (Einspeisevergütung): stała stawka za kWh przez 20 lat od uruchomienia, wysokość regularnie spada dla nowo uruchamianych instalacji - wcześniejszy start zwykle zapewnia wyższą stawkę',
        'Kredyt KfW 270: finansowanie na preferencyjnych warunkach, warunki zmieniają się na bieżąco',
      ],
    },
    { type: 'heading', text: 'Ważna zmiana od 2027: zapowiedziana reforma EEG' },
    {
      type: 'paragraph',
      text:
        'Niemieckie Federalne Ministerstwo Gospodarki zapowiedziało w projekcie ustawy zniesienie ' +
        'stałej taryfy gwarantowanej dla nowych instalacji do 25 kWp od 2027 roku - operatorzy ' +
        'mieliby zamiast tego sprzedawać nadwyżkę energii bezpośrednio na giełdzie energii. Na ' +
        'sierpień 2026 to projekt, nie ostatecznie uchwalona ustawa - kto uruchomi instalację ' +
        'jeszcze w 2026 roku, zabezpiecza sobie obowiązującą wówczas stałą taryfę na pełne 20 lat, ' +
        'niezależnie od reformy.',
    },
    { type: 'heading', text: 'Landy i gminy: bardzo różnie w zależności od regionu' },
    {
      type: 'paragraph',
      text:
        'Tylko część niemieckich krajów związkowych (landów) ma obecnie własne programy ' +
        'dofinansowania - kilka wcześniejszych programów krajowych zakończono bez następcy. ' +
        'Dotacje gminne (czasem sięgające niskich pięciocyfrowych kwot, bardzo różnie w zależności ' +
        'od gminy) są więc często istotniejszym poziomem. Aktualny przegląd, filtrowany według landu ' +
        'i grupy docelowej, oferuje publiczna baza danych dofinansowań rządu federalnego ' +
        '(foerderdatenbank.de) - tam znajdą Państwo faktycznie obowiązujące programy dla swojego ' +
        'miejsca zamieszkania, bardziej aktualne niż jakakolwiek statyczna lista.',
    },
    { type: 'heading', text: 'Co to oznacza dla Państwa porównania ofert' },
    {
      type: 'paragraph',
      text:
        'Dofinansowanie niczego nie zmienia w podstawowej logice porównania: uczciwym kryterium ' +
        'pozostaje cena przed dofinansowaniem, ponieważ dofinansowanie obowiązuje niezależnie od ' +
        'wybranej firmy instalatorskiej. W Roofora najpierw porównują Państwo niewiążące oferty z ' +
        'ceną stałą od kilku firm - dopiero potem warto spojrzeć na odpowiednie dla Państwa programy ' +
        'dofinansowania.',
    },
  ],
  faq: [
    {
      q: 'Czy wniosek o dofinansowanie muszę złożyć przed czy po otrzymaniu ofert?',
      a: 'W praktycznie wszystkich programach krajowych i gminnych wniosek o dofinansowanie trzeba złożyć, zanim instalacja zostanie kupiona lub zamontowana - zaplanuj to od razu po otrzymaniu pierwszych ofert, nie dopiero po wyborze wykonawcy.',
    },
    {
      q: 'Dlaczego ta strona nie podaje szczegółowych stawek dofinansowania dla poszczególnych landów?',
      a: 'Ponieważ programy krajowe i gminne zmieniają się na bieżąco, a my nie jesteśmy w stanie utrzymywać dla nich wiarygodnej, aktualnej własnej bazy danych - oficjalna baza dofinansowań rządu federalnego (foerderdatenbank.de) jest do tego bardziej wiarygodnym, aktualizowanym na bieżąco źródłem.',
    },
    {
      q: 'Czy moja taryfa gwarantowana zmieni się wstecznie, jeśli zmieni się prawo?',
      a: 'Nie - taryfa obowiązująca w momencie uruchomienia instalacji jest stała przez 20 lat, niezależnie od późniejszych zmian prawnych dla nowych instalacji.',
    },
  ],
  primaryCta: { label: 'Porównaj oferty za darmo już teraz', action: 'customer' },
  secondaryCta: { label: 'Jak obliczamy cenę orientacyjną', action: 'link', href: '/jak-obliczamy-cene' },
  relatedLinks: [
    { label: 'Ile kosztuje instalacja solarna?', href: '/koszt-instalacji-fotowoltaicznej' },
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
  ],
}
